import React from 'react';

import { WizardContextProvider } from 'ui-components/components/wizard/context';
import { WizardFooter } from 'ui-components/components/wizard/wizard-footer';
import { WizardHeader } from 'ui-components/components/wizard/wizard-header';
import { WizardStep } from 'ui-components/components/wizard/wizard-step';
import { noop } from 'ui-components/default-props/noop';

import style from './style.module.less';

/**
 * @param {object} props
 * @param {React.ReactNode | React.ReactNode[]} props.children
 * @param {(stepId: string) => string} props.getStepLabel
 * @param {() => void} [props.onComplete]
 * @param {React.ReactNode} [props.footer]
 * @param {boolean} [props.allowInitialProgress]
 * @param {(stepId: string) => void} [props.setCurrentStepId]
 * @param {string | null} [props.initialStepId]
 * @param {boolean} [props.hideStepLabels]
 * @returns {React.ReactElement}
 */
export const Wizard = ({
  children,
  getStepLabel,
  onComplete = noop,
  footer = null,
  allowInitialProgress = false,
  setCurrentStepId = noop,
  initialStepId = null,
  hideStepLabels = false,
}) => {
  const wizardChildren = React.Children.toArray(children);
  const wizardStepIds = wizardChildren
    .filter((child) => {
      // @ts-expect-error - React.Children.toArray can contain various types
      return child.type?.displayName === WizardStep.displayName;
    })
    .map((child) => {
      // @ts-expect-error - We've filtered to only React elements
      return child.props.stepId;
    });
  return (
    <WizardContextProvider
      allowInitialProgress={allowInitialProgress}
      getStepLabel={getStepLabel}
      initialStepId={initialStepId}
      onComplete={onComplete}
      setCurrentStepId={setCurrentStepId}
      wizardStepIds={wizardStepIds}
    >
      <div className={style['wizard-wrapper']}>
        {!hideStepLabels && (
          <div className={style['wizard-header']}>
            {wizardStepIds.map((stepId) => (
              <WizardHeader key={stepId} stepId={stepId} />
            ))}
          </div>
        )}
        {children}
        <div className={style['footer-wrapper']}>{footer ?? <WizardFooter />}</div>
      </div>
    </WizardContextProvider>
  );
};
